module.exports = __webpack_public_path__ + "24f75238a3ba11a6b50ef42b49add882.pdf";